import { render, staticRenderFns } from "./group-introduction.vue?vue&type=template&id=3bf08ef0"
import script from "./group-introduction.vue?vue&type=script&lang=js"
export * from "./group-introduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports